import axios from 'axios';

const axiosInstance = axios.create();

axiosInstance.interceptors.response.use(
  response => response,
  async error => {
    if (error.response?.status === 401) {
      const currentUrl = window.location.href;
      const postLoginRedirectUri = encodeURIComponent(currentUrl);
      window.location.href = `/authorization/refresh-token?postLoginRedirect=${postLoginRedirectUri}`;
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
